/* Mercado shop layer (session 6, final pass). Loaded deferred from layout/theme.liquid after mercado-fixes.js and theme.js.
   1. Quick add: [data-mc-add] adds a single-variant product; [data-mc-choose] opens an accessible <dialog> selector.
      Nothing is pre-selected (except a product's only purchasable choice), unavailable values are disabled, a value
      that only clashes with the current choice stays selectable and clears the clashing choice (no dead ends), and
      the add button stays disabled until a purchasable variant is chosen. Price, picture, stock line and the cart line
      always describe the same variant. Stale or failed product requests never overwrite a newer dialog.
      Cart writes go through jQuery so the cart queue / locale prefix in mercado-fixes.js apply; the theme's own
      mini-cart refresh (theme.miniCart) updates the count, total and drawer afterwards.
   2. Countdown [data-mc-cd]: ticks against the server clock, hides itself at zero (no negative / 00 timer).
   3. Campaign schedule [data-mc-sched]: every campaign-aware section (hero, looks, complete the look) leaves a marker.
      At the start/end boundary, when the countdown ends, or when a backgrounded tab comes back after the boundary,
      all of them are re-rendered together in one Section Rendering API request built from the current URL
      (so ?view=halloween, ?preview_theme_id … are kept) and swapped in place, then re-armed.
   4. Hero video [data-mc-video]: loads only after the page has loaded, only when visible, never with
      prefers-reduced-motion or Save-Data/2G/3G, pauses off-screen and in hidden tabs; the poster stays if playback
      fails or is blocked.
   5. Looks tabs [data-mc-looks], complete-the-look [data-mc-ctl], product strip progress [data-mc-strip].
   6. Recently viewed [data-mc-rv]: the store's own product cards (sections/mc-card-render) for the theme's history list.
   7. Desktop menu: one row; items that do not fit move into a "More" dropdown; dropdowns near an edge open inwards.
   8. Store chat button and store-credit (Koin) reward line in the page language.
   Strings come from window.mcShop (snippets/mc-shop-strings.liquid). No literal \u escapes in this file (the upload
   tool decodes them) — use String.fromCharCode. */
(function () {
  'use strict';
  if (window.mcShopReady) return;
  window.mcShopReady = true;

  var S = window.mcShop || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = window.jQuery;
  var rtl = document.documentElement.getAttribute('dir') === 'rtl';
  var ar = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ar') === 0;

  function t(key, vars) {
    var s = S[key] != null ? String(S[key]) : key;
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    try { if (window.theme && theme.Currency && theme.moneyFormat) return String(theme.Currency.formatMoney(cents, theme.moneyFormat)).replace(/<[^>]*>/g, ''); } catch (e) {}
    return (cents / 100).toFixed(2) + ' ' + (S.currency || '');
  }
  function bdi(text) { return '<bdi class="mc-money">' + esc(text) + '</bdi>'; }
  /* for textContent (buttons): keep "50.00 NIS" in order inside Arabic text */
  var LRI = String.fromCharCode(0x2066), PDI = String.fromCharCode(0x2069);
  function iso(text) { return LRI + text + PDI; }
  function imgUrl(src, w) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  /* "N items" with Arabic number agreement (1 / 2 / 3–10 / 11+) */
  function items(n) {
    if (ar) { if (n === 1) return S.item1 || 'منتج واحد'; if (n === 2) return S.item2 || 'منتجان'; if (n >= 3 && n <= 10) return n + ' ' + (S.itemFew || 'منتجات'); return n + ' ' + (S.itemMany || 'منتجاً'); }
    return n === 1 ? '1 ' + (S.itemOne || 'item') : n + ' ' + (S.itemOther || 'items');
  }
  var liveEl;
  function announce(msg) {
    if (!liveEl) { liveEl = document.createElement('p'); liveEl.className = 'mc-live'; liveEl.setAttribute('role', 'status'); liveEl.setAttribute('aria-live', 'polite'); document.body.appendChild(liveEl); }
    liveEl.textContent = '';
    setTimeout(function () { liveEl.textContent = msg; }, 60);
  }
  function idle(fn) { if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 2500 }); else setTimeout(fn, 1200); }
  function errText(msg) { return msg ? msg : t('error'); }

  /* ---------------- cart ---------------- */
  function refreshCart() {
    try { if (window.theme && theme.miniCart && theme.miniCart.updateElements) { theme.miniCart.updateElements(); theme.miniCart.generateCart(); return; } } catch (e) {}
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.js-cart-count').forEach(function (el) { el.textContent = '(' + c.item_count + ')'; });
    }).catch(function () {});
  }
  function addItems(list) {
    return new Promise(function (resolve, reject) {
      var ok = function (data) { refreshCart(); resolve(data); };
      var bad = function (xhr) { var msg = ''; try { msg = JSON.parse(xhr.responseText).description || ''; } catch (e) {} reject(msg); };
      if ($ && $.ajax) {
        $.ajax({ type: 'POST', url: '/cart/add.js', data: { items: list }, dataType: 'json' }).done(ok).fail(bad);
      } else {
        fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(ok).catch(function (j) { reject((j && j.description) || ''); });
      }
    });
  }

  /* ---------------- direct add (single-variant products) ---------------- */
  function btnState(btn, state, text) {
    if (!btn._mcHtml) btn._mcHtml = btn.innerHTML;
    btn.classList.remove('is-loading', 'is-added');
    if (state) btn.classList.add('is-' + state);
    if (text == null) btn.innerHTML = btn._mcHtml; else btn.textContent = text;
  }
  function cardError(btn, msg) {
    var card = btn.closest('.mc-n') || btn.parentNode;
    var p = card.querySelector('.mc-n__err');
    if (!p) { p = document.createElement('p'); p.className = 'mc-n__err'; p.setAttribute('role', 'alert'); card.appendChild(p); }
    p.textContent = msg;
    clearTimeout(p._t);
    p._t = setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 6000);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-mc-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    btnState(btn, 'loading', t('adding'));
    btn.setAttribute('aria-busy', 'true');
    addItems([{ id: Number(btn.getAttribute('data-variant')), quantity: 1 }]).then(function () {
      btn.removeAttribute('aria-busy');
      btnState(btn, 'added', t('added'));
      announce(t('addedStatus', { title: btn.getAttribute('data-title') || '' }));
      setTimeout(function () { btnState(btn, null, null); }, 2600);
    }, function (msg) {
      btn.removeAttribute('aria-busy');
      btnState(btn, null, null);
      cardError(btn, errText(msg));
      announce(errText(msg));
    });
  });

  /* ---------------- selector dialog (shades / sizes / options) ---------------- */
  var dlg, cur = null, seq = 0, ctrl = null;
  function kindOf(name, nOpt) {
    var n = String(name || '').toLowerCase();
    if (/shade|درجة/.test(n)) return 'shade';
    if (/colou?r|لون/.test(n)) return nOpt > 1 ? 'color' : 'shade';
    if (/size|volume|حجم/.test(n)) return 'size';
    return 'other';
  }
  function optLabel(name, nOpt) {
    var k = kindOf(name, nOpt);
    if (k === 'shade') return t('shade');
    if (k === 'color') return t('color');
    if (k === 'size') return t('size');
    return name || t('option');
  }
  function chooseText(name, nOpt) {
    if (nOpt > 1) return t('chooseOptions');
    var k = kindOf(name, nOpt);
    return k === 'shade' ? t('chooseShade') : k === 'size' ? t('chooseSize') : t('chooseOptions');
  }
  function ensureDialog() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'mc-qa';
    dlg.setAttribute('aria-labelledby', 'mc-qa-title');
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () {
      /* the close event is queued: if another chooser opened in the meantime, it belongs to that one */
      if (dlg.open) return;
      var trg = cur && cur.trigger;
      cur = null;
      if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; }
      if (trg && trg.focus && document.contains(trg)) trg.focus();
    });
    return dlg;
  }
  function loadingBody(text, link) {
    return '<div class="mc-qa__in"><div class="mc-qa__grab" aria-hidden="true"></div><p class="mc-qa__load" id="mc-qa-title" role="status">' + esc(text) + '</p>' +
      (link ? '<a class="mc-qa__more" href="' + esc(link) + '">' + esc(t('details')) + '</a>' : '') +
      '<button type="button" class="mc-btn mc-btn--link mc-qa__dismiss" data-qa-close>' + esc(t('close')) + '</button></div>';
  }
  function openChooser(trigger) {
    var handle = trigger.getAttribute('data-handle');
    var fallbackUrl = trigger.getAttribute('data-url') || (root + 'products/' + handle);
    var d = ensureDialog();
    if (typeof d.showModal !== 'function') { window.location.href = fallbackUrl; return; }
    if (ctrl) { try { ctrl.abort(); } catch (e) {} }
    ctrl = window.AbortController ? new AbortController() : null;
    var my = ++seq;
    cur = { trigger: trigger, seq: my };
    d.innerHTML = loadingBody(t('loading'));
    d.querySelector('[data-qa-close]').addEventListener('click', function () { d.close(); });
    if (!d.open) d.showModal();
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (p) { if (cur && cur.seq === my) renderChooser(d, p, trigger, my); })
      .catch(function (err) {
        if (!cur || cur.seq !== my || (err && err.name === 'AbortError')) return;
        d.innerHTML = loadingBody(t('loadError'), fallbackUrl);
        d.querySelector('[data-qa-close]').addEventListener('click', function () { d.close(); });
      });
  }
  function renderChooser(d, p, trigger, my) {
    var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var nOpt = names.length || 1;
    var values = [];
    for (var i = 0; i < nOpt; i++) {
      var seen = {}; values[i] = [];
      p.variants.forEach(function (v) { var val = v['option' + (i + 1)]; if (val != null && !seen[val]) { seen[val] = 1; values[i].push(val); } });
    }
    var avail = p.variants.filter(function (v) { return v.available; });
    var sel = new Array(nOpt);
    for (var s0 = 0; s0 < nOpt; s0++) sel[s0] = null;
    /* an option with exactly one purchasable value is chosen for the customer (e.g. 345 Relief Cream: only 50ml) */
    for (var s1 = 0; s1 < nOpt; s1++) {
      var only = null, many = false;
      avail.forEach(function (v) { var val = v['option' + (s1 + 1)]; if (only === null) only = val; else if (only !== val) many = true; });
      if (only !== null && !many && values[s1].length > 1) sel[s1] = only;
    }
    var detailsBase = root + 'products/' + p.handle;
    var html = '<form method="dialog" class="mc-qa__in" novalidate>' +
      '<div class="mc-qa__grab" aria-hidden="true"></div>' +
      '<div class="mc-qa__head"><span class="mc-qa__thumb"><img data-qa-img src="' + esc(imgUrl(p.featured_image, 160)) + '" alt="" width="56" height="56"></span>' +
      '<div class="mc-qa__info"><p class="mc-qa__brand">' + esc(p.vendor || '') + '</p><h2 class="mc-qa__title" id="mc-qa-title">' + esc(p.title) + '</h2><p class="mc-qa__price" data-qa-price></p></div>' +
      '<button type="button" class="mc-qa__x" data-qa-close aria-label="' + esc(t('close')) + '">' + String.fromCharCode(0x2715) + '</button></div>';
    for (var o = 0; o < nOpt; o++) {
      html += '<fieldset data-qa-opt="' + o + '"><legend>' + esc(optLabel(names[o], nOpt)) + ': <bdi data-qa-legend="' + o + '">' + esc(t('choosePrompt')) + '</bdi></legend><div class="mc-qa__opts">';
      values[o].forEach(function (val) {
        var vImg = '';
        if (o === 0) { for (var k = 0; k < p.variants.length; k++) { var vv = p.variants[k]; if (vv.option1 === val && vv.featured_image) { vImg = imgUrl(vv.featured_image, 140); break; } } }
        html += '<label class="mc-qa__opt"><input type="radio" name="mcqa' + o + '" value="' + esc(val) + '">' +
          '<span class="mc-qa__sw">' + (vImg ? '<img src="' + esc(vImg) + '" alt="" loading="lazy" width="56" height="56">' : '<b>' + esc(val) + '</b>') + '</span>' +
          '<span class="mc-qa__on">' + esc(val) + '</span></label>';
      });
      html += '</div></fieldset>';
    }
    html += '<p class="mc-qa__stock" data-qa-stock role="status"></p>' +
      '<button type="button" class="mc-btn mc-btn--primary mc-qa__add" data-qa-add disabled></button>' +
      '<a class="mc-qa__more" data-qa-more href="' + esc(detailsBase) + '">' + esc(t('details')) + '</a></form>';
    d.innerHTML = html;

    var priceEl = d.querySelector('[data-qa-price]'), stock = d.querySelector('[data-qa-stock]'), add = d.querySelector('[data-qa-add]');
    var more = d.querySelector('[data-qa-more]'), thumb = d.querySelector('[data-qa-img]');
    function fits(v, skip) {
      for (var x = 0; x < nOpt; x++) { if (x === skip || sel[x] == null) continue; if (v['option' + (x + 1)] !== sel[x]) return false; }
      return true;
    }
    function match() {
      for (var x = 0; x < nOpt; x++) if (sel[x] == null) return null;
      for (var i = 0; i < p.variants.length; i++) if (fits(p.variants[i], -1)) return p.variants[i];
      return null;
    }
    function exists(o, val) { return avail.some(function (v) { return v['option' + (o + 1)] === val; }); }
    function compatible(o, val) { return avail.some(function (v) { return v['option' + (o + 1)] === val && fits(v, o); }); }
    function consistent() { return avail.some(function (v) { return fits(v, -1); }); }
    function syncRadios() {
      d.querySelectorAll('fieldset[data-qa-opt]').forEach(function (fs) {
        var o = Number(fs.getAttribute('data-qa-opt'));
        fs.querySelectorAll('input').forEach(function (inp) { inp.checked = sel[o] != null && inp.value === sel[o]; });
      });
    }
    function update() {
      d.querySelectorAll('fieldset[data-qa-opt]').forEach(function (fs) {
        var o = Number(fs.getAttribute('data-qa-opt'));
        fs.querySelectorAll('input').forEach(function (inp) {
          var ok = exists(o, inp.value), fit = ok && compatible(o, inp.value);
          inp.disabled = !ok;
          var lab = inp.closest('.mc-qa__opt');
          lab.classList.toggle('is-sold', !ok);
          lab.classList.toggle('is-clash', ok && !fit);
          inp.setAttribute('aria-label', inp.value + (!ok ? ' — ' + t('soldTag') : (!fit ? ' — ' + t('clashTag') : '')));
        });
        var leg = d.querySelector('[data-qa-legend="' + o + '"]');
        leg.textContent = sel[o] != null ? sel[o] : t('choosePrompt');
      });
      var v = match();
      if (v && v.available) {
        priceEl.innerHTML = bdi(money(v.price)) + (v.compare_at_price > v.price ? ' <s>' + bdi(money(v.compare_at_price)) + '</s>' : '');
        stock.textContent = t('available');
        stock.classList.remove('is-error');
        add.disabled = false;
        add.textContent = t('addWithPrice', { price: iso(money(v.price)) });
        more.href = detailsBase + '?variant=' + v.id;
        if (v.featured_image) thumb.src = imgUrl(v.featured_image, 160);
      } else {
        /* price range of what can still be bought with the current partial choice */
        var cand = avail.filter(function (x) { return fits(x, -1); });
        if (!cand.length) cand = avail;
        var lo = null, hi = null;
        cand.forEach(function (x) { if (!lo || x.price < lo.price) lo = x; if (!hi || x.price > hi.price) hi = x; });
        if (lo && hi && hi.price > lo.price) priceEl.innerHTML = esc(t('from')) + ' ' + bdi(money(lo.price));
        else if (lo) priceEl.innerHTML = bdi(money(lo.price)) + (lo.compare_at_price > lo.price ? ' <s>' + bdi(money(lo.compare_at_price)) + '</s>' : '');
        else priceEl.textContent = '';
        stock.textContent = '';
        add.disabled = true;
        var missing = null;
        for (var o2 = 0; o2 < nOpt; o2++) if (sel[o2] == null) { missing = names[o2]; break; }
        add.textContent = chooseText(missing, nOpt);
        more.href = detailsBase;
        if (sel[0] != null) { for (var k = 0; k < cand.length; k++) if (cand[k].featured_image && cand[k].option1 === sel[0]) { thumb.src = imgUrl(cand[k].featured_image, 160); break; } }
      }
    }
    d.querySelectorAll('input[type="radio"]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var o = Number(inp.closest('fieldset').getAttribute('data-qa-opt'));
        sel[o] = inp.value;
        /* a choice that clashes with another option clears that option instead of trapping the customer */
        for (var x = 0; x < nOpt; x++) { if (x !== o && sel[x] != null && !consistent()) sel[x] = null; }
        /* an option left with a single purchasable value is filled in for the customer */
        for (var y = 0; y < nOpt; y++) {
          if (y === o || sel[y] != null) continue;
          var vals = values[y].filter(function (val) { return compatible(y, val); });
          if (vals.length === 1) sel[y] = vals[0];
        }
        syncRadios();
        update();
      });
    });
    d.querySelectorAll('[data-qa-close]').forEach(function (b) { b.addEventListener('click', function () { d.close(); }); });
    add.addEventListener('click', function () {
      var v = match();
      if (!v || !v.available || add.classList.contains('is-loading')) return;
      add.classList.add('is-loading'); add.setAttribute('aria-busy', 'true'); add.textContent = t('adding');
      addItems([{ id: v.id, quantity: 1 }]).then(function () {
        announce(t('addedStatus', { title: p.title + (v.public_title ? ' · ' + v.public_title : '') }));
        if (trigger && trigger.classList && document.contains(trigger)) { btnState(trigger, 'added', t('added')); setTimeout(function () { btnState(trigger, null, null); }, 2600); }
        if (cur && cur.seq === my && d.open) d.close();
      }, function (msg) {
        if (!cur || cur.seq !== my) return;
        add.classList.remove('is-loading'); add.removeAttribute('aria-busy');
        update();
        stock.textContent = errText(msg); stock.classList.add('is-error');
      });
    });
    syncRadios();
    update();
    /* the loading view that had focus was replaced: keep focus inside the dialog on every screen size
       (first choice on desktop; the close button on phones, so the sheet does not jump) */
    var first = d.querySelector('input:not([disabled])');
    var wide = window.matchMedia && matchMedia('(min-width: 750px)').matches;
    var target = (wide && first) ? first : (d.querySelector('.mc-qa__x') || first);
    if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
  }
  document.addEventListener('click', function (e) {
    var trg = e.target.closest ? e.target.closest('[data-mc-choose]') : null;
    if (!trg) return;
    e.preventDefault();
    openChooser(trg);
  });

  /* ---------------- countdown ---------------- */
  function pad(n) { n = Math.max(0, Math.floor(n)); return (n < 10 ? '0' : '') + n; }
  function digits(el, str) {
    if (!el || el._v === str) return;
    el._v = str;
    var h = ''; for (var i = 0; i < str.length; i++) h += '<i>' + str.charAt(i) + '</i>';
    el.innerHTML = h;
  }
  function setupCountdown(cd) {
    if (cd._mc) return; cd._mc = true;
    var end = Number(cd.getAttribute('data-end')) || 0, now = Number(cd.getAttribute('data-now')) || 0;
    if (!end) return;
    var off = now ? now - Math.floor(Date.now() / 1000) : 0;
    var u = { d: cd.querySelector('[data-u="d"]'), h: cd.querySelector('[data-u="h"]'), m: cd.querySelector('[data-u="m"]'), s: cd.querySelector('[data-u="s"]') };
    function tick() {
      var rem = end - (Math.floor(Date.now() / 1000) + off);
      if (rem <= 0) {
        clearInterval(cd._t); cd._t = null;
        if (!cd.classList.contains('is-done')) {
          cd.classList.add('is-done');
          cd.dispatchEvent(new CustomEvent('mc:countdown-done', { bubbles: true }));
        }
        return false;
      }
      digits(u.d, pad(rem / 86400)); digits(u.h, pad((rem % 86400) / 3600)); digits(u.m, pad((rem % 3600) / 60)); digits(u.s, pad(rem % 60));
      return true;
    }
    /* the interval only starts while there is time left (an expired countdown fires its event once) */
    if (tick()) cd._t = setInterval(tick, 1000);
  }

  /* ---------------- campaign schedule: all campaign sections switch together ---------------- */
  var sched = { timer: null, busy: false, tries: 0, off: 0, boundary: 0 };
  function serverNow() { return Math.floor(Date.now() / 1000) + sched.off; }
  function markers() { return [].slice.call(document.querySelectorAll('[data-mc-sched]')); }
  function armSchedule() {
    clearTimeout(sched.timer); sched.timer = null; sched.boundary = 0;
    if (window.Shopify && Shopify.designMode) return;
    var ms = markers();
    if (!ms.length) return;
    var now = Number(ms[0].getAttribute('data-now')) || 0;
    sched.off = now ? now - Math.floor(Date.now() / 1000) : 0;
    ms.forEach(function (m) {
      var b = Number(m.getAttribute('data-boundary')) || 0;
      if (m.getAttribute('data-auto') === '1' && b > 0 && (!sched.boundary || b < sched.boundary)) sched.boundary = b;
    });
    if (!sched.boundary) return;
    var delay = (sched.boundary - serverNow() + 1) * 1000;
    if (delay < 0) delay = 0;
    if (delay === 0 && sched.tries > 0) return;
    if (delay <= 2147483647) sched.timer = setTimeout(refreshCampaign, delay);
  }
  function sectionUrl(ids) {
    var u = new URL(window.location.href);
    u.hash = '';
    u.searchParams.set('sections', ids.join(','));
    u.searchParams.set('mc_t', String(Date.now()));
    return u.pathname + u.search;
  }
  function refreshCampaign() {
    if (sched.busy || (window.Shopify && Shopify.designMode)) return;
    var ms = markers().filter(function (m) { return m.getAttribute('data-auto') === '1'; });
    var ids = []; ms.forEach(function (m) { var id = m.getAttribute('data-sid'); if (id && ids.indexOf(id) < 0) ids.push(id); });
    if (!ids.length) return;
    sched.busy = true;
    clearTimeout(sched.timer); sched.timer = null;
    var wraps = function (fn) { ids.forEach(function (id) { var w = document.getElementById('shopify-section-' + id); if (w) fn(w); }); };
    wraps(function (w) { w.classList.add('is-switching'); });
    var retry = function () {
      sched.busy = false;
      wraps(function (w) { w.classList.remove('is-switching'); });
      if (sched.tries < 3) { sched.tries++; sched.timer = setTimeout(refreshCampaign, 30000 * sched.tries); }
    };
    /* no Accept: application/json header — on a collection URL it makes Shopify answer with the collection JSON */
    fetch(sectionUrl(ids.slice(0, 5)), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (map) {
        var replaced = 0;
        ids.forEach(function (id) {
          var html = map && map[id];
          var old = document.getElementById('shopify-section-' + id);
          if (typeof html !== 'string' || !old) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('shopify-section-' + id);
          if (!fresh) return;
          teardown(old);
          old.parentNode.replaceChild(fresh, old);
          init(fresh);
          replaced++;
        });
        if (!replaced) { retry(); return; }
        sched.busy = false;
        /* an answer rendered before the boundary (cache) still points at the passed boundary: ask again shortly */
        var nb = 0; markers().forEach(function (m) { var b = Number(m.getAttribute('data-boundary')) || 0; if (b && (!nb || b < nb)) nb = b; });
        if (nb && nb <= serverNow()) { retry(); return; }
        sched.tries = 0;
        armSchedule();
      })
      .catch(retry);
  }
  document.addEventListener('mc:countdown-done', function () { refreshCampaign(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && sched.boundary && serverNow() >= sched.boundary) refreshCampaign();
  });

  /* ---------------- hero video ---------------- */
  function setupVideo(hero) {
    var v = hero.querySelector('video[data-mc-video]');
    var btn = hero.querySelector('[data-mc-motion]');
    if (!v || v._mc) return; v._mc = true;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var c = navigator.connection || {};
    var slow = !!c.saveData || /(^|-)(2g|3g)$/.test(c.effectiveType || '');
    var src = (window.matchMedia && matchMedia('(min-width: 750px)').matches) ? v.getAttribute('data-src-d') : v.getAttribute('data-src-m');
    if (reduce || slow || !src) { hero.classList.add('mc-still'); if (btn) btn.hidden = true; return; }
    var loaded = false, userPaused = false, visible = false;
    function load() { if (loaded) return; loaded = true; v.src = src; }
    function play() {
      if (userPaused || !visible || document.hidden) return;
      load();
      var pr = v.play();
      /* only a real refusal (autoplay blocked) keeps the poster; an interrupted start is retried when the page is shown again */
      if (pr && pr.catch) pr.catch(function (e) { if (e && e.name === 'NotAllowedError') hero.classList.add('mc-still'); });
    }
    hero._mcVisV = function () { if (document.hidden) { if (loaded) v.pause(); } else play(); };
    document.addEventListener('visibilitychange', hero._mcVisV);
    v.addEventListener('playing', function () { hero.classList.add('is-video'); });
    v.addEventListener('error', function () { hero.classList.remove('is-video'); hero.classList.add('mc-still'); if (btn) btn.hidden = true; });
    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        userPaused = !userPaused;
        btn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        btn.querySelector('[data-mc-motion-label]').textContent = userPaused ? t('play') : t('pause');
        var ic = btn.querySelector('.mc-cx__motion-i'); if (ic) ic.textContent = userPaused ? String.fromCharCode(0x25B6) : String.fromCharCode(0x275A, 0x275A);
        hero.classList.toggle('is-paused', userPaused);
        if (userPaused) v.pause(); else play();
      });
    }
    var start = function () {
      if (!document.contains(hero)) return;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { visible = en.isIntersecting; if (visible) play(); else if (loaded) v.pause(); });
        }, { threshold: 0.15 });
        io.observe(hero); hero._mcIO = io;
      } else { visible = true; play(); }
    };
    if (document.readyState === 'complete') idle(start); else window.addEventListener('load', function () { idle(start); }, { once: true });
  }

  /* ---------------- product strip progress ---------------- */
  function setupStrip(wrap) {
    var list = wrap.querySelector('.mc-strip'), bar = wrap.querySelector('.mc-strip-progress span');
    if (!list || !bar || list._mc) return; list._mc = true;
    var upd = function () {
      var max = list.scrollWidth - list.clientWidth;
      wrap.classList.toggle('is-static', max <= 2);
      if (max <= 2) { bar.parentNode.style.visibility = 'hidden'; return; }
      bar.parentNode.style.visibility = '';
      var r = Math.min(1, Math.abs(list.scrollLeft) / max);
      bar.style.insetInlineStart = (r * 60) + '%';
    };
    list.addEventListener('scroll', upd, { passive: true });
    wrap._mcResize = upd;
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---------------- looks tabs ---------------- */
  function setupLooks(sec) {
    if (sec._mc) return; sec._mc = true;
    var tabs = [].slice.call(sec.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    function select(i, focus) {
      tabs.forEach(function (tab, k) {
        var on = k === i;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      var tint = tabs[i].getAttribute('data-tint');
      if (tint) sec.style.setProperty('--mc-look-tint', tint);
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null, n = tabs.length;
        var fwd = rtl ? 'ArrowLeft' : 'ArrowRight', back = rtl ? 'ArrowRight' : 'ArrowLeft';
        if (e.key === fwd || e.key === 'ArrowDown') next = (i + 1) % n;
        else if (e.key === back || e.key === 'ArrowUp') next = (i - 1 + n) % n;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = n - 1;
        if (next != null) { e.preventDefault(); select(next, true); }
      });
    });
    sec.addEventListener('shopify:block:select', function (e) {
      var i = tabs.indexOf(e.target.closest ? e.target.closest('[role="tab"]') : null);
      if (i > -1) select(i, false);
    });
    var c = tabs.findIndex(function (tb) { return tb.getAttribute('aria-selected') === 'true'; });
    select(c > -1 ? c : 0, false);
  }

  /* ---------------- complete the look ---------------- */
  function setupCtl(sec) {
    if (sec._mc) return; sec._mc = true;
    var list = [].slice.call(sec.querySelectorAll('[data-ctl-item]'));
    var totalEl = sec.querySelector('[data-ctl-total]'), countEl = sec.querySelector('[data-ctl-count]'), addBtn = sec.querySelector('[data-ctl-add]'), note = sec.querySelector('[data-ctl-note]');
    var baseNote = note ? note.textContent : '';
    function itemVariant(it) {
      var s = it.querySelector('select');
      if (s) { var o = s.options[s.selectedIndex]; return o && o.value ? { id: Number(o.value), price: Number(o.getAttribute('data-price')) } : null; }
      var id = it.getAttribute('data-variant');
      return id ? { id: Number(id), price: Number(it.getAttribute('data-price')) } : null;
    }
    function say(msg) { if (note) note.textContent = msg || baseNote; }
    function refresh() {
      var sel = [], total = 0;
      list.forEach(function (it) {
        var box = it.querySelector('[role="checkbox"]');
        if (box.getAttribute('aria-checked') !== 'true') return;
        var v = itemVariant(it);
        if (v) { sel.push(v); total += v.price; }
      });
      totalEl.textContent = money(total);
      if (countEl) countEl.textContent = sel.length ? items(sel.length) : '';
      addBtn.disabled = sel.length === 0;
      addBtn.textContent = sel.length ? t('addSelected') : t('pickItems');
      sec._mcSel = sel;
    }
    list.forEach(function (it) {
      var box = it.querySelector('[role="checkbox"]'), s = it.querySelector('select');
      box.addEventListener('click', function () {
        if (box.getAttribute('aria-disabled') === 'true') return;
        var on = box.getAttribute('aria-checked') === 'true';
        if (!on && s && !s.value) { s.focus(); say(t('needsShade')); return; }
        box.setAttribute('aria-checked', on ? 'false' : 'true');
        it.classList.toggle('is-on', !on);
        say('');
        refresh();
      });
      box.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); box.click(); } });
      if (s) s.addEventListener('change', function () {
        var o = s.options[s.selectedIndex];
        var price = it.querySelector('[data-ctl-price]');
        if (o && o.value) {
          if (price) price.innerHTML = bdi(money(Number(o.getAttribute('data-price'))));
          box.setAttribute('aria-checked', 'true'); it.classList.add('is-on');
          say('');
        } else {
          box.setAttribute('aria-checked', 'false'); it.classList.remove('is-on');
        }
        refresh();
      });
    });
    addBtn.addEventListener('click', function () {
      var sel = sec._mcSel || [];
      if (!sel.length || addBtn.classList.contains('is-loading')) return;
      addBtn.classList.add('is-loading'); addBtn.setAttribute('aria-busy', 'true'); addBtn.textContent = t('adding');
      addItems(sel.map(function (v) { return { id: v.id, quantity: 1 }; })).then(function () {
        addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy');
        addBtn.textContent = t('added');
        announce(t('added') + ' (' + items(sel.length) + ')');
        setTimeout(refresh, 2600);
      }, function (msg) {
        addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy');
        say(errText(msg));
        refresh();
      });
    });
    refresh();
  }

  /* ---------------- recently viewed (store product cards, same price rules as every list) ---------------- */
  function setupRecent(sec) {
    if (sec._mc) return; sec._mc = true;
    var listEl = sec.querySelector('[data-mc-rv-list]');
    if (!listEl) return;
    var hist = [];
    try { hist = JSON.parse(localStorage.getItem('localRecentlyViewed')) || []; } catch (e) { hist = []; }
    var current = sec.getAttribute('data-current') || '';
    var limit = Number(sec.getAttribute('data-limit')) || 4;
    var handles = [];
    for (var i = hist.length - 1; i >= 0 && handles.length < limit; i--) {
      var h = String(hist[i] || '');
      if (h && h !== current && handles.indexOf(h) < 0) handles.push(h);
    }
    if (!handles.length) return;
    var load = function () {
      Promise.all(handles.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=mc-card-render', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (parts) {
        var html = '';
        parts.forEach(function (part) {
          if (!part) return;
          var doc = new DOMParser().parseFromString(part, 'text/html');
          var li = doc.querySelector('.mc-rv__item');
          if (li) html += li.outerHTML;
        });
        if (!html || !document.contains(sec)) return;
        listEl.innerHTML = html;
        sec.hidden = false;
        try { if (window.lazySizes && lazySizes.loader) lazySizes.loader.checkElems(); } catch (e) {}
      });
    };
    /* after the page has loaded, when the browser is idle (four small requests, never before the page itself) */
    if (document.readyState === 'complete') idle(load); else window.addEventListener('load', function () { idle(load); }, { once: true });
  }

  /* ---------------- desktop menu: one row, overflow into "More", dropdowns open inwards ---------------- */
  var navMore = null;
  function navList() { return document.querySelector('.site-nav'); }
  function restoreNav(ul) {
    if (!navMore) return;
    var moved = navMore._mcMoved || [];
    moved.forEach(function (li) { ul.insertBefore(li, navMore); });
    if (navMore.parentNode) navMore.parentNode.removeChild(navMore);
    navMore._mcMoved = [];
  }
  function buildMore() {
    var li = document.createElement('li');
    li.className = 'site-nav__item site-nav__item-normal mc-more';
    li.innerHTML = '<button type="button" class="site-nav__link mc-more__toggle" aria-haspopup="true" aria-expanded="false"><span class="site-nav__title">' + esc(t('more')) + '</span></button>' +
      '<div class="site-nav__dropdown meganav mc-more__drop"><ul class="meganav__list mc-more__list"></ul></div>';
    var tg = li.querySelector('.mc-more__toggle');
    tg.addEventListener('click', function (e) { e.preventDefault(); var open = li.classList.toggle('is-open'); tg.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    li.addEventListener('keydown', function (e) { if (e.key === 'Escape') { li.classList.remove('is-open'); tg.setAttribute('aria-expanded', 'false'); tg.focus(); } });
    document.addEventListener('click', function (e) { if (!li.contains(e.target)) { li.classList.remove('is-open'); tg.setAttribute('aria-expanded', 'false'); } });
    li._mcMoved = [];
    return li;
  }
  function oneRow(ul) {
    var lis = [].filter.call(ul.children, function (x) { return x.offsetParent !== null; });
    if (lis.length < 2) return true;
    var top = lis[0].offsetTop;
    for (var i = 1; i < lis.length; i++) if (lis[i].offsetTop > top + 4) return false;
    return true;
  }
  function fitNavRow() {
    var ul = navList();
    if (!ul) return;
    restoreNav(ul);
    if (ul.offsetParent === null || window.innerWidth < 990) return;
    if (oneRow(ul)) return;
    if (!navMore) navMore = buildMore();
    ul.appendChild(navMore);
    var list = navMore.querySelector('.mc-more__list');
    list.innerHTML = '';
    var guard = 0;
    while (!oneRow(ul) && guard++ < 30) {
      var cand = navMore.previousElementSibling;
      if (!cand) break;
      navMore._mcMoved.unshift(cand);
      ul.removeChild(cand);
    }
    /* each moved menu item becomes a column: its title, then its own links (nothing is lost) */
    navMore._mcMoved.forEach(function (li) {
      var a = li.querySelector('a.site-nav__link');
      if (!a) return;
      var title = (a.textContent || '').replace(/\s+/g, ' ').trim();
      var href = a.getAttribute('href');
      var col = document.createElement('li');
      col.className = 'mc-more__col';
      col.innerHTML = (href && href !== '#') ? '<a class="mc-more__h" href="' + esc(href) + '">' + esc(title) + '</a>' : '<span class="mc-more__h">' + esc(title) + '</span>';
      var sub = document.createElement('ul');
      sub.className = 'mc-more__sub';
      /* menu links only (normal and mega columns); product cards shown inside a mega menu are left out */
      li.querySelectorAll('.site-nav__dropdown a.meganav__link, .site-nav__dropdown .mega-link .menu-title > a, .site-nav__dropdown .mega-link .nav-links a').forEach(function (x) {
        var hh = x.getAttribute('href'), tt = (x.textContent || '').replace(/\s+/g, ' ').trim();
        if (!tt) return;
        var item = document.createElement('li');
        item.innerHTML = (hh && hh !== '#') ? '<a class="meganav__link" href="' + esc(hh) + '">' + esc(tt) + '</a>' : '<span class="mc-more__label">' + esc(tt) + '</span>';
        sub.appendChild(item);
      });
      if (sub.children.length) col.appendChild(sub);
      list.appendChild(col);
    });
    if (!navMore._mcMoved.length && navMore.parentNode) navMore.parentNode.removeChild(navMore);
  }
  function fitNav() {
    fitNavRow();
    var lis = document.querySelectorAll('.site-nav > li');
    if (!lis.length) return;
    var w = document.documentElement.clientWidth;
    lis.forEach(function (li) {
      var dd = li.querySelector('.site-nav__dropdown');
      if (!dd) return;
      li.classList.remove('mc-flip');
      var r = li.getBoundingClientRect(), dw = dd.offsetWidth || 280;
      if (r.width === 0) return;
      var out = rtl ? (r.right - dw < 8) : (r.left + dw > w - 8);
      if (out) li.classList.add('mc-flip');
    });
  }
  /* Escape closes the open desktop dropdown (they open on hover and on keyboard focus) and returns focus to its top link */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var a = document.activeElement;
    var item = a && a.closest ? a.closest('.site-nav > li') : null;
    if (!item || item.classList.contains('mc-more') || !item.querySelector('.site-nav__dropdown')) return;
    item.classList.add('mc-esc');
    var top = item.querySelector('a.site-nav__link, button.site-nav__link');
    if (top && top !== a) top.focus();
  });
  document.addEventListener('focusout', function (e) {
    var item = e.target && e.target.closest ? e.target.closest('.site-nav > li.mc-esc') : null;
    if (item && !(e.relatedTarget && item.contains(e.relatedTarget))) item.classList.remove('mc-esc');
  });
  document.addEventListener('mouseover', function (e) {
    var item = e.target && e.target.closest ? e.target.closest('.site-nav > li.mc-esc') : null;
    if (item && !item.contains(document.activeElement)) item.classList.remove('mc-esc');
  });
  var fitT;
  window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fitNav, 150); });
  if (document.readyState === 'complete') fitNav(); else window.addEventListener('load', fitNav);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { setTimeout(fitNav, 50); });

  /* ---------------- store chat button: label in the page language ---------------- */
  function localizeChat() {
    var label = S.chatLabel;
    if (!label) return;
    var data = document.getElementById('shopify-chat-app-embed-data');
    if (data && !data._mc) {
      data._mc = true;
      try {
        var j = JSON.parse(data.textContent);
        if (j && j.settings && typeof j.settings.buttonLabel === 'string' && j.settings.buttonLabel) { j.settings.buttonLabel = label; data.textContent = JSON.stringify(j); }
      } catch (e) {}
    }
    /* if the button was already drawn before this script ran, update its visible label and name only */
    var tries = 0;
    var fix = function () {
      var host = document.querySelector('shopify-chat');
      var btn = host && host.shadowRoot && host.shadowRoot.querySelector('[part~="activator"]');
      if (btn) {
        if (btn.getAttribute('aria-label') && btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
        var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
        var n; while ((n = walker.nextNode())) { if (n.nodeValue.trim() && n.nodeValue.trim() !== label) { n.nodeValue = label; break; } }
        return;
      }
      if (++tries < 20) setTimeout(fix, 500);
    };
    fix();
  }

  /* ---------------- store-credit app (Koin): reward line in the page language ----------------
     The app renders from its own window._Koin data after this script (its script is deferred and comes later).
     Only the wording changes; the amount placeholder, eligibility and conditions stay the app's own. */
  function localizeReward() {
    var K = window._Koin;
    if (!K || !K.entries || !K.entries.length || !S.rewardProduct) return;
    K.entries.forEach(function (en) {
      /* only the purchase cashback programme ("order-based"); any other kind of reward keeps the app's own wording */
      if (!en || en.type !== 'order-based') return;
      if (en && typeof en.description === 'string' && en.description.indexOf('{koin_amount}') > -1) en.description = S.rewardProduct;
      if (en && typeof en.cart_description === 'string' && en.cart_description.indexOf('{koin_amount}') > -1 && S.rewardCart) en.cart_description = S.rewardCart;
    });
  }

  /* ---------------- init / teardown (also for the theme editor) ---------------- */
  function each(scope, sel, fn) { (scope || document).querySelectorAll(sel).forEach(fn); if (scope && scope.matches && scope.matches(sel)) fn(scope); }
  function init(scope) {
    scope = scope || document;
    each(scope, '[data-mc-cd]', setupCountdown);
    each(scope, '[data-mc-hero]', setupVideo);
    each(scope, '[data-mc-strip]', setupStrip);
    each(scope, '[data-mc-looks]', setupLooks);
    each(scope, '[data-mc-ctl]', setupCtl);
    each(scope, '[data-mc-rv]', setupRecent);
  }
  function teardown(scope) {
    each(scope, '[data-mc-cd]', function (cd) { clearInterval(cd._t); });
    each(scope, '[data-mc-strip]', function (w) { if (w._mcResize) window.removeEventListener('resize', w._mcResize); });
    each(scope, '[data-mc-hero]', function (h) { if (h._mcIO) h._mcIO.disconnect(); if (h._mcVisV) document.removeEventListener('visibilitychange', h._mcVisV); var v = h.querySelector('video'); if (v) { v.pause(); v.removeAttribute('src'); v.load(); } });
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); armSchedule(); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
  window.mcShopInit = init;
  window.mcShopDebug = { refreshCampaign: refreshCampaign, armSchedule: armSchedule, sched: sched, fitNav: fitNav };
  localizeReward();
  function boot() { init(document); armSchedule(); localizeChat(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
